export const getPrincipal = (sharePrice: number, numberOfShares: number) =>
  sharePrice * numberOfShares;
